import * as React from 'react';
import RcCollapse from 'rc-collapse';
import classNames from 'classnames';
import OutlinedRight from 'acud-icon/lib/icons/OutlinedRight';
import toArray from 'rc-util/lib/Children/toArray';
import CollapsePanel from './CollapsePanel';
import { ConfigContext } from '../config-provider';
import collapseMotion from '../_util/motion';
import { cloneElement } from '../_util/reactNode';
const Collapse = props => {
    const { getPrefixCls } = React.useContext(ConfigContext);
    const { prefixCls: customizePrefixCls, className = '' } = props;
    const prefixCls = getPrefixCls('collapse', customizePrefixCls);
    const renderExpandIcon = (panelProps = {}) => {
        const icon = (<OutlinedRight rotate={panelProps.isActive ? 90 : undefined}/>);
        return cloneElement(icon, () => ({
            className: classNames(icon.props.className, `${prefixCls}-arrow`)
        }));
    };
    const openMotion = Object.assign(Object.assign({}, collapseMotion), { motionAppear: false, leavedClassName: `${prefixCls}-content-hidden` });
    const getItems = () => {
        const { children } = props;
        return toArray(children).map((child, index) => {
            var _a;
            if ((_a = child.props) === null || _a === void 0 ? void 0 : _a.disabled) {
                const key = child.key || String(index);
                const childProps = Object.assign(Object.assign({}, child.props), { key });
                return cloneElement(child, childProps);
            }
            return child;
        });
    };
    return (<RcCollapse openMotion={openMotion} {...props} expandIcon={renderExpandIcon} prefixCls={prefixCls} className={className}>
            {getItems()}
        </RcCollapse>);
};
Collapse.Panel = CollapsePanel;
export default Collapse;
